import React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { MenuData, MenuTextData } from "../models/types";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AppsIcon from '@material-ui/icons/Apps';
import MoreIcon from '@material-ui/icons/MoreVert';
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import ProductCategories from "./ProductCategories";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
    },
    headerMenu: {
      boxShadow: "none",
      backgroundColor: "#4e342e"
    },
    headerProducts: {
      boxShadow: "none",
      backgroundColor: "#ebdcc4"
    },
    menuItem: {
      border: "solid",
      borderRadius: "4px",
      borderColor: "#ebdcc4",
      borderWidth: "thin",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#FFF"
      }
    },
    menuItemLink: {
      fontSize: "12px",
      color: "#000000",
      textDecoration: "none"
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    menuButtonDark: {
      color: "#ffffff",
      border: "0px",
      height: "64px",
      width: "200px",
      borderRadius: "0px"
    },
    menuButtonLightCatalog: {
      color: "#212121",
      backgroundColor: "#ebdcc4",
      border: "0px",
      height: "64px",
      width: "200px",
      borderRadius: "0px",
      "&:hover": {
        color: "#212121",
        backgroundColor: "#ebdcc4",
      },
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    inputRoot: {
      color: 'inherit',
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    popoverPaper: {
      width: '100%',
      maxHeight: 'calc(100vh - 140px)',
      overflowY: 'auto',
    },
  }),
);

interface PropsFromState {
  loading: boolean;
  errors?: string;
  menu: MenuData[];
  text: MenuTextData;
}

interface propsFromDispatch {
}

type AllProps = PropsFromState & propsFromDispatch;

const MenuLine: React.FC<AllProps> = ({
  loading,
  errors,
  menu,
  text
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  }

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  }

  React.useEffect(() => {
    document.body.style.overflow = anchorEl ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [anchorEl]);

  return (
    <>
      <AppBar color="secondary" position="static">
        <Toolbar >
          <Button
            className={classes.menuButtonLightCatalog}
            aria-label={intl.formatMessage({ id: "aria.showMore" })}
            onClick={handleClick}
            onMouseEnter={handleClick}
          >
            <AppsIcon /> <FormattedMessage id="nav.catalog" />
          </Button>
          <div className={classes.sectionDesktop}>
            <Link to="/about"><Button className={classes.menuButtonDark}><FormattedMessage id="nav.about" /></Button></Link>
            <Link to="/become-client"><Button className={classes.menuButtonDark}><FormattedMessage id="nav.becomeClient" /></Button></Link>
            <Link to="/contacts"><Button className={classes.menuButtonDark}><FormattedMessage id="nav.contacts" /></Button></Link>
          </div>
          <div className={classes.sectionMobile}>
            <Button
              aria-label={intl.formatMessage({ id: "aria.showMore" })}
              className={classes.menuButtonDark}
              onClick={handleMobileMenuOpen}
            >
              <FormattedMessage id="nav.more" /> <MoreIcon />
            </Button>
          </div>
        </Toolbar>
      </AppBar>

      <Menu
        PopoverClasses={{ paper: classes.popoverPaper }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        id="category-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}>
        <ProductCategories />
      </Menu>
      <Menu
        PopoverClasses={{ paper: classes.popoverPaper }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        id="small-menu"
        anchorEl={mobileMoreAnchorEl}
        getContentAnchorEl={null}
        open={Boolean(isMobileMenuOpen)}
        onClose={handleMobileMenuClose}
      >
        <MenuItem>
          <Link to="/about" className={classes.menuItemLink} onClick={handleMobileMenuClose}>
            <FormattedMessage id="nav.about" />
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/become-client" className={classes.menuItemLink} onClick={handleMobileMenuClose}>
            <FormattedMessage id="nav.becomeClient" />
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/contacts" className={classes.menuItemLink} onClick={handleMobileMenuClose}>
            <FormattedMessage id="nav.contacts" />
          </Link>
      </MenuItem>
      </Menu>
    </>
  );
};

const mapStateToProps = ({ menu }: ApplicationState) => ({
  loading: menu.loading,
  errors: menu.errors,
  menu: menu.menu,
  text: menu.text
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuLine);
